import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

// export const paymentTypeFunction = createAsyncThunk(
//   "order/paymentTypeFunction",
//   async ({order_id, type , wallet_pay , order_status , wallet_money } , { rejectWithValue }) => {
//     try {
//       const response = await PrivateAxios.post(
//         `/api/user/payment/type`,
//         { order_id , type , wallet_pay , order_status , wallet_money },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.data.status) {
//         return rejectWithValue(response.data.message || "Invalid status.");
//       }

//       return response.data.data.orders;
//     } catch (error) {
//       console.error("Error fetching orders:", error.message);
//       return rejectWithValue(
//         error.response?.data || error.request || "Failed to fetch orders"
//       );
//     }
//   }
// );

// export const paymentTypeFunction = createAsyncThunk(
//   "order/paymentTypeFunction",
//   async (
//     { order_id, type, wallet_pay, order_status, wallet_money },
//     { rejectWithValue }
//   ) => {
//     try {
//       const response = await PrivateAxios.post(
//         `/api/user/payment/type`,
//         { order_id, type, wallet_pay, order_status, wallet_money },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       // API response as string (assuming it includes the HTML content)
//       const responseData = response.data;

//       // Check if the response includes the meta refresh tag
//       if (typeof responseData === "string" && responseData.includes("<meta http-equiv=\"refresh\"")) {
//         // Extract the URL from the meta tag
//         const urlMatch = responseData.match(/content="1;URL='(.*?)'/);
//         if (urlMatch && urlMatch[1]) {
//           return urlMatch[1]; // Return the extracted URL
//         } else {
//           throw new Error("Redirect URL not found in the response.");
//         }
//       }

//       // Handle JSON responses or unexpected formats
//       if (!response.data.status) {
//         return rejectWithValue(response.data.message || "Invalid status.");
//       }

//       return response.data.data; // Return other data if needed
//     } catch (error) {
//       console.error("Error fetching orders:", error.message);
//       return rejectWithValue(
//         error.response?.data?.message || "Failed to process payment."
//       );
//     }
//   }
// );

export const paymentTypeFunction = createAsyncThunk(
  "order/paymentTypeFunction",
  async (
    { order_id, type, wallet_pay, order_status, wallet_money },
    { rejectWithValue }
  ) => {
    try {
      const response = await PrivateAxios.post(
        `/api/user/payment/type`,
        { order_id, type, wallet_pay, order_status, wallet_money },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.status) {
        return rejectWithValue(response.message);
      }

      return response.data;
    } catch (error) {
      console.error("Error pay order:", error.message);

      const errorMessage = error.response || "Failed to pay order";

      return rejectWithValue(errorMessage);
    }
  }
);

const initialState = {
  paymentType: null,
  status: "idle",
  error: null,
};

const paymentTypeSlice = createSlice({
  name: "paymentType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(paymentTypeFunction.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(paymentTypeFunction.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.paymentType = action.payload;
      })
      .addCase(paymentTypeFunction.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default paymentTypeSlice.reducer;
